import { Link } from 'react-router-dom';
import type { Game } from '@/services/api-client';

interface UnderConstructionTileProps {
  game: Game;
}

// IMA-431: Rendered in the TODAY slot of PlayerProgressStream when contentAvailability === 'under_construction'.
// Matches the fluid clamp() sizing of renderEnhancedTodayChallenge.
// IS-INV-025: no hardcoded game names or IDs.
export function UnderConstructionTile({ game }: UnderConstructionTileProps) {
  return (
    <div className="h-[clamp(44px,12vw,64px)] md:h-[clamp(56px,8vw,80px)] xl:h-[clamp(40px,3.5vw,60px)] p-[clamp(2px,0.6vw,6px)] md:p-[clamp(4px,1vw,8px)] xl:p-[clamp(3px,0.35vw,6px)] rounded-lg border border-gray-200 dark:border-gray-500 bg-white dark:bg-gray-600 flex flex-col items-center justify-center text-center gap-1">
      <div className="font-oswald font-bold text-[clamp(7px,1.8vw,10px)] md:text-[clamp(8px,0.9vw,12px)] uppercase tracking-[0.5px] text-foreground leading-none">
        Under construction
      </div>
      <Link
        to={`/games/${game.id}/archive`}
        aria-label={`Play ${game.displayName} archive`}
        className="font-oswald text-[clamp(6px,1.5vw,9px)] md:text-[clamp(7px,0.75vw,10px)] uppercase tracking-[0.3px] text-muted-foreground underline leading-none"
      >
        Play our archive
      </Link>
    </div>
  );
}
